module.exports = __webpack_public_path__ + "static/media/IMG_047.2d1ee520.JPG";